import { ISpecOfferDetailItem } from '@r1-frontend/api-domru/spec-offer/v1/spec-offers/dto/ISpecOffer';

const maxAdvantagesQuantity = 4;

export interface ISpecOfferAdvantage extends ISpecOfferDetailItem {
    isWide: boolean,
}

export const getWidthMark = (items: ISpecOfferDetailItem[]): ISpecOfferAdvantage[] => {
    const advantages = items.slice(0, maxAdvantagesQuantity);
    const withWidthMark: ISpecOfferAdvantage[] = advantages.map(advantage => ({ ...advantage, isWide: true }));

    if (withWidthMark.length >= 3) {
        withWidthMark[1].isWide = false;
        withWidthMark[2].isWide = false;
    }

    return withWidthMark;
};
